import { useQuery } from '@tanstack/react-query';
import { getEmailPreferences } from '../api/email-preferences.api';

export const EMAIL_PREFERENCES_QUERY_KEY = ['account', 'email-preferences'] as const;

/**
 * The signed-in member's optional-email preference (FR-164).
 *
 * Its own query, not a field read off `useProfile`: the preference lives on the
 * user and must work for every persona, including ones whose `/me` profile read
 * does not apply, so the card renders independently of the profile.
 */
export function useEmailPreferences() {
  return useQuery({
    queryKey: EMAIL_PREFERENCES_QUERY_KEY,
    queryFn: getEmailPreferences,
  });
}
